'use client';

import { useEffect, useRef } from 'react';

export const useClickOutside = <T>(callback: any) => {
  const ref = useRef<T>(null);

  const handleClick = (event: MouseEvent) => {
    if (ref?.current && !ref.current?.contains(event.target)) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  });

  return ref;
};
